module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-mindfulness-skills-large.af7f6e70.png";